import { InputState } from '../../components/input/input.state';

export interface MultiChooserGroupItem {
	color?: string;
	key: string;
	value: string;
}

export interface MultiChooserGroup {
	title: string;
	items: MultiChooserGroupItem[];
	selected: string;
}

export abstract class MultiChooserState extends InputState<string[]> {
	private _groups: MultiChooserGroup[] | null = null;
	public get groups(): MultiChooserGroup[] | null {
		return this._groups;
	}
	public set groups(value: MultiChooserGroup[] | null) {
		this._groups = value;
	}

	constructor(label: string) {
		super(label);
		this.readOnly = true;
	}

	private _displayValue: string;
	public get displayValue(): string {
		return this._displayValue;
	}
	public set displayValue(value: string) {
		this._displayValue = value;
	}

	abstract selectDefaultValue(): void;

	getAllOptions(): MultiChooserGroupItem[][] {
		const allOptions: MultiChooserGroupItem[][] = [];

		const groups = this.groups;
		if (groups == null) {
			return allOptions;
		}

		//we only keep the last selected node. If intermediate nodes are important, this function needs to be overwritten (see NestedListChooserState)
		for (let group of groups) {
			for (let item of group.items) {
				allOptions.push([item]);
			}
		}
		return allOptions;
	}
}
